module.exports = __webpack_public_path__ + "501a338edc18b33b910e8d7b33116b3e.svg";